var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "root-container no-margin",
      style: { minWidth: _vm.minRootWidth, minHeight: _vm.minRootHeight },
    },
    [
      _c(
        "div",
        {
          class: { page: true, dragging: _vm.dragging },
          style: _vm.pageStyle,
          on: {
            mousemove: function ($event) {
              return _vm.onMouseMove($event)
            },
          },
        },
        [
          _vm._l(_vm.layout.TextBlocks, function (block) {
            return _c("app-text-block", {
              key: block.key,
              attrs: { block: block, layout: _vm.layout, model: _vm.model },
            })
          }),
          _vm._l(_vm.layout.Barcodes, function (barcode) {
            return _c("app-barcode", {
              key: barcode.key,
              attrs: { barcode: barcode },
            })
          }),
          _vm._l(_vm.layout.QrCodes, function (qrcode) {
            return _c("app-qr-code", {
              key: qrcode.key,
              attrs: { qrcode: qrcode },
            })
          }),
          _vm._l(_vm.layout.Images, function (image) {
            return _c("app-image", { key: image.key, attrs: { image: image } })
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }